import React from 'react';

export const DeleteAnnouncement = ({ announcement }) => (
    <>
        <strong>Announcement Type</strong>
        <br />
        <span>{announcement.announcementType}</span>
        <br />
        <br />
        <strong>Announcement</strong>
        <br />
        <span>{announcement.announcement}</span>
    </>
);